import { useMutation } from '@tanstack/react-query';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { RequiredKeysDataSchema } from '../schema/RequiredKeyDataSchema';
import { DataObjectDescriptionVersionUrl } from './DataObjectDescriptionVersionUrl';
import { RcFile } from 'antd/es/upload';
import { RequiredKeyDataType } from '../schema';
import { expand } from 'uri-template-lite';

interface IArgs {
  file: string | Blob | RcFile;
  id?: number;
}

export const useMutateKeysUpload = (onProgress?: (progress: number) => void) =>
  useMutation<RequiredKeyDataType[], ApiErrorResponse, IArgs>({
    mutationKey: ['requiredKeysUpload'],
    mutationFn: ({ file, id }) =>
      apiClient
        .post(
          expand(DataObjectDescriptionVersionUrl.uploadKeys, { id }),
          {
            file,
          },
          {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progress) => {
              if (!progress.total) {
                return;
              }
              onProgress?.((progress.loaded / progress.total) * 100);
            },
          },
        )
        .then((response) => RequiredKeysDataSchema.parse(response.data)),
  });
